import { render, staticRenderFns } from "./LogosSingleAnswer.vue?vue&type=template&id=6bd0ce54&scoped=true&lang=html&"
import script from "./LogosSingleAnswer.vue?vue&type=script&lang=js&"
export * from "./LogosSingleAnswer.vue?vue&type=script&lang=js&"
import style0 from "./LogosSingleAnswer.vue?vue&type=style&index=0&id=6bd0ce54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd0ce54",
  null
  
)

component.options.__file = "LogosSingleAnswer.vue"
export default component.exports